


















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import RemovePartnerBrandRepTrigger from './RemovePartnerBrandRepTrigger.coffee'

settings =
  name: 'RemovePartnerBrandRepTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator }
    mixins: [RemovePartnerBrandRepTrigger.trigger()]

    computed:
      brand_rep: -> @modal?.config?.brand_rep || {}
export default VueOptions.vue settings
